import { getUser } from '../AppServices';
import { MODELS } from '../Lib/constants';

export const appraiseEmployeeListUri = ({ filter = {}, params } = {}) => {
  return {
    query: {
      id: 'appraiseEmployeeListForTable',
      addOnFilter: {
        dealer: { _id: getUser()?.dealer?._id },
      },
    },
    aggregate: true,
    model: MODELS.APPRAISE_EMPLOYEE,
  };
};

export const EditAppraiseEmployeeURI = ({ navigation }) => {
  return {
    query: {
      model: MODELS.APPRAISE_EMPLOYEE,
      id: 'getAppraiseEmployeeDetails',
      relationValue: {
        model: MODELS.APPRAISE_EMPLOYEE,
        _id: navigation?.state?.params?.item?._id,
        relation: '_id',
      },
      limit: 1,
    },
    model: MODELS.APPRAISE_EMPLOYEE,
  };
};

export const EditEmployeeURI = ({ navigation }) => {
  return {
    query: {
      model: MODELS.APPRAISE_EMPLOYEE,
      id: 'getAppraiseEmployeeDetails',
      relationValue: {
        model: MODELS.APPRAISE_EMPLOYEE,
        _id: navigation?.state?.params?.item?._id,
        relation: '_id',
      },
      limit: 1,
    },
    model: MODELS.APPRAISE_EMPLOYEE,
  };
};
